import ServerError from 'errors/ServerError';
import { useGetCustomService } from './useGetCustomService';

export const useGetSecurityAllocations = ({
    advisoryId, afterOptimization = false, enabled, showSecurityAllocationChart = true,
}) => {
    const securityAllocations = useGetCustomService({
        service: 'customAdvisoryServices',
        api: 'getSecurityAllocations',
        payload: { advisoryId, includeInvestmentApplications: false },
        enabled: enabled && showSecurityAllocationChart,
        gcTime: 0,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });

    const securityAllocationsAfterOptimization = useGetCustomService({
        service: 'customAdvisoryServices',
        api: 'getSecurityAllocations',
        payload: { advisoryId, includeInvestmentApplications: true },
        enabled: enabled && !!afterOptimization,
        gcTime: 0,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });

    const error = securityAllocations?.error || securityAllocationsAfterOptimization?.error;
    const status = securityAllocations?.data?.status || securityAllocationsAfterOptimization?.data?.status;

    return {
        securityAllocations: showSecurityAllocationChart ? securityAllocations?.data : null,
        securityAllocationsAfterOptimization: securityAllocationsAfterOptimization?.data || null,
        statusCode: status,
        error: error ? new ServerError(error) : error,
    };
};
